import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const request = createAppRequest();

export interface OpenPlatformM2mToken {
  accessToken: string;
  permissions: string;
  exp: number;
  iat: number;
}

export function issueOpenPlatformM2mToken(options?: ApiRequestOptions) {
  return request<OpenPlatformM2mToken>('/bff/open-platform/m2m-token', {
    method: 'POST',
    ...(options || {}),
  });
}
